import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { StagesComponent } from '../../../../../common/stages/stages.component';
import { CemeterySiteDetailsForm } from './forms/cemetery-site-details.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../store/actions/application.actions';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../common/validation-errors/validation-errors.component';
import { GraveNumberLabelPipe } from '../../../../../pipes/grave-number/grave-number-label.pipe';
import { GraveNumberPlaceholderPipe } from '../../../../../pipes/grave-number/grave-number-placeholder.pipe';
import { DatePickerComponent } from '../../../../../common/date-picker/date-picker.component';
import { NgxMaskDirective } from 'ngx-mask';

export interface CemeterySiteDetailsComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
  addPersonDataControls?: boolean;
}

@Component({
  selector: 'app-cemetery-site-details-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    GraveNumberLabelPipe,
    GraveNumberPlaceholderPipe,
    DatePickerComponent,
    NgxMaskDirective
  ],
  providers: [CemeterySiteDetailsForm],
  templateUrl: './cemetery-site-details-section.component.html'
})
export class CemeterySiteDetailsSectionComponent implements OnInit, OnDestroy {

  public form: CemeterySiteDetailsForm = inject(CemeterySiteDetailsForm);

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = this.route.snapshot.data['stages'] || [];

  public successUrl: string = this.route.snapshot.data['successUrl'];

  public cancelUrl: string = this.route.snapshot.data['cancelUrl'];

  public applicationId: string = this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.applicationId || '',
        application: this.form.toWriteModel(),
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnInit(): void {
    if (this.route.snapshot.data['addPersonDataControls']) {
      this.form.createPersonDataControls();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
